import { FormattedNumber } from 'react-intl';

export const Rate = ({
    className,
    value,
    decimalPlaces = 2
}: {
    className?: string;
    value: number;
    decimalPlaces?: number;
}) => (
    <VariableRate
        className={className}
        value={value}
        maximumFractionDigits={decimalPlaces}
        minimumFractionDigits={decimalPlaces}
    />
);

export const VariableRate = ({
    className,
    value,
    maximumFractionDigits,
    minimumFractionDigits
}: {
    className?: string;
    value: number;
    maximumFractionDigits: number;
    minimumFractionDigits: number;
}) => (
    <FormattedNumber
        // @ts-expect-error
        className={className}
        maximumFractionDigits={maximumFractionDigits}
        minimumFractionDigits={minimumFractionDigits}
        value={value}
        style="percent"
    />
);
